import "./interact.scss";
const Interact = ({ programid }) => {
  return <livelike-widgets programid={programid} />;
};
export default Interact;
